import { CartAddressesApi } from '@/gen/ecom/apis'
import { ecomConfiguration } from './apiConfigs'

export const cartAddressesClient = new CartAddressesApi(ecomConfiguration)
